/* Import Modules */
import axios, { AxiosRequestConfig } from "axios";
import toastr from "toastr";

/* Import Variables */
import { isShow, searchParams, schedules } from "../../variables";

/* Define Function */
const getAxiosOptions = () => {
  const axiosOptions: AxiosRequestConfig = {
    url: "/api/schedule",
    method: "GET",
    params: searchParams,
  };

  return axiosOptions;
};

export const getSchedules = async () => {
  // Get Axios Option
  const axiosOptions = await getAxiosOptions();
  await axios(axiosOptions)
    .then((result) => {
      // Set Schedules
      schedules.daily = result.data.daily_schedules;
      schedules.unset = result.data.datetime_unset_schedules;
    })
    .catch((error) => {
      console.log(error);
      toastr.error("スケジュール情報取得に失敗しました");
    });
  isShow.initDisplay = false;
};
